<template>
	<v-dialog v-model="dialog" width="960">
		<template v-slot:activator="{ on: dialog }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn large icon v-on="{ ...tooltip, ...dialog }">
						<v-icon>mdi-alpha-r-circle</v-icon>
					</v-btn>
				</template>
				<span>Rule(s)</span>
			</v-tooltip>
		</template>

		<v-card raised class="pb-2">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Manage Rules</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog"
					><v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text class="pt-3 pb-2">
				<div>
					<v-form ref="form" v-model="valid" lazy-validation="">
						<v-row>
							<v-col>
								<v-text-field
									label="Rule Name"
									v-model="rule.name"
									outlined
									dense
									clearable
									hide-details="auto"
								></v-text-field>
							</v-col>
							<v-col>
								<v-select
									label="Rule Type"
									outlined
									dense
									v-model="rule.ruleType"
									:items="rule_type_options"
									hide-details="auto"
								></v-select>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<v-text-field
									label="Group Url"
									v-model="rule.group"
									outlined
									dense
									clearable
									hide-details="auto"
								></v-text-field>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<v-select
									:items="statusItems"
									item-text="text"
									item-value="value"
									v-model="rule.type"
									outlined
									dense
									clearable
									hide-details="auto"
									label="Group Type"
								></v-select>
							</v-col>

							<v-col>
								<v-text-field
									label="Group Extension"
									v-model="rule.extension"
									outlined
									dense
									clearable
									hide-details="auto"
								></v-text-field>
							</v-col>

							<v-col>
								<v-text-field
									label="Updated By"
									v-model="rule.updated_by"
									outlined
									dense
									clearable
									hide-details="auto"
								></v-text-field>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<v-select
									label="Date Type"
									outlined
									dense
									v-model="rule.date_field"
									:items="date_field_options"
									hide-details="auto"
								></v-select>
							</v-col>
							<v-col>
								<v-menu
									ref="startMenu"
									v-model="startMenu"
									:close-on-content-click="false"
									offset-y
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="startDateFormatted"
											label="Start Date"
											placeholder="MM/DD/YYYY"
											persistent-hint
											clearable
											outlined
											dense
											hide-details="auto"
											v-on:keyup.enter="
												rule.start_date = parseDate(startDateFormatted)
											"
											@blur="rule.start_date = parseDate(startDateFormatted)"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="rule.start_date"
										no-title
										color="secondary"
										@input="startMenu = false"
										:max="
											rule.end_date
												? parseDate(rule.end_date)
												: parseDate(today)
										"
									></v-date-picker>
								</v-menu>
							</v-col>
							<v-col>
								<v-menu
									ref="endMenu"
									v-model="endMenu"
									:close-on-content-click="false"
									offset-y
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="endDateFormatted"
											label="End Date"
											placeholder="MM/DD/YYYY"
											persistent-hint
											clearable
											outlined
											dense
											hide-details="auto"
											v-on:keyup.enter="
												rule.end_date = parseDate(endDateFormatted)
											"
											@blur="rule.end_date = parseDate(endDateFormatted)"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="rule.end_date"
										no-title
										color="secondary"
										@input="endMenu = false"
										:min="rule.start_date"
										:max="parseDate(today)"
									></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>
					</v-form>
				</div>
				<div>
					<div>Active Rules</div>
					<BaseActiveRules @removedRule="removedRule" />
				</div>
			</v-card-text>

			<v-card-actions class="px-6 pt-0 pb-4">
				<v-spacer></v-spacer>
				<v-btn text @click="resetRules">Clear All Rules</v-btn>
				<v-btn color="success" dark @click="addRule">Apply Rule</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
	props: ["headers"],
	data() {
		return {
			dialog: false,
			valid: true,
			statusItems: [
				{ text: "Domain", value: "domain" },
				{ text: "Subdomain", value: "subdomain" },
			],
			rules: [],
			ruleNames: new Set(),
			rule: {
				ruleType: true,
				date_field: "created_at",
			},
			endMenu: false,
			startMenu: false,
			startDateFormatted: null,
			endDateFormatted: null,
			date_field_options: [
				{ value: "created_at", text: "Created" },
				{ value: "updated_at", text: "Updated" },
			],
			rule_type_options: [
				{ value: true, text: "Good" },
				{ value: false, text: "Bad" },
			],
			dateFormat: {
				format: "MM/DD/YYYY",
				parse: "YYYY-MM-DD",
				display: "MMM D, YYYY",
			},
		};
	},
	methods: {
		replaceUndefinedOrNull(key, value) {
			if (value === null || value === undefined) {
				return undefined;
			}
			return value;
		},
		parseDate(date) {
			if (!date) return null;
			return moment(date).format(this.dateFormat.parse);
		},
		formatDate(date) {
			if (!date) return null;
			return moment(date).format(this.dateFormat.format);
		},
		addRule() {
			console.log(this.rule);
			console.log(this.rule.name);
			if (
				this.rule.name !== undefined &&
				this.rule.name !== null &&
				this.rule.name !== ""
			) {
				if (
					this.activerules.length === 0 ||
					!this.ruleNames.has(this.rule.name)
				) {
					this.$store.dispatch("rules/addRule", this.rule);
					this.ruleNames.add(this.rule.name);
					this.$emit("rulesUpdated");
					this.rule = this.getDefaultrule();
				} else {
					alert("Error: Rule name already exists");
				}
			} else {
				alert("Error: You must enter a name");
			}
		},
		resetRules() {
			this.$store.dispatch("rules/clearRules");
			this.$emit("rulesUpdated");
			this.rules = [];
			this.ruleNames.clear();
		},
		getDefaultrule() {
			return {
				ruleType: true,
				url: null,
				domain: null,
				subdomain: null,
				anchor_text: null,
				pre_text: null,
				title_tag: null,
				page_topic: null,
				start_date: null,
				name: null,
				end_date: null,
				date_field: "created_at",
			};
		},
		getHeader(id) {
			let header = this.headers.find((header) => header.value === id);
			return header ? header : false;
		},
		getHeaderType(id) {
			let header = this.getHeader(id);
			return header ? header.ruleType : false;
		},
		getHeaderText(id) {
			let header = this.getHeader(id);
			return header ? header.text : false;
		},
		removedRule(name) {
			this.ruleNames.delete(name);
			this.$emit("rulesUpdated");
		},
		closeDialog() {
			this.dialog = false;
			this.rule = this.getDefaultrule();
		},
	},
	watch: {
		"rule.start_date"(val) {
			this.startDateFormatted = this.formatDate(val);
		},
		"rule.end_date"(val) {
			this.endDateFormatted = this.formatDate(val);
		},
	},
	computed: {
		today() {
			return moment();
		},
		...mapGetters({
			activerules: "rules/rules",
		}),
	},
	created() {
		if (this.activerules.length !== 0) {
			this.rules = this.activerules;
			this.rules.forEach((elem) => this.ruleNames.add(elem.name));
		} else {
			this.rules = [];
		}
	},
};
</script>

<style></style>
